<section class="help-list-page container">
  <!-- section header -->
  <h1 class="help-list-page__header">
    {{ 'global.helpCenter' | translate }}
  </h1>
  <div class="help-list-page__content">
    <!-- titles box -->
    <div class="titles-list">
      @for (topic of helpTopics; track topic._id) {
        <li class="titles-list">
          <!-- <pwj-content-titles-box
            [titleBoxData]="topic.title"></pwj-content-titles-box> -->
        </li>
      }
    </div>

    <div class="help-list-page__help">
      <!-- section bar -->
      <pwj-section-bar
        barTitle="global.loginAndSignUpProcess"
        dataTitle="global.video"
        [dataCount]="23"
        icon="user-2"></pwj-section-bar>
      <!-- list -->
      <div class="help-list-page__list">
        <ul class="help-list">
          @for (helpData of helps; track helpData._id) {
            <li class="help-list__item">
              <pwj-help-card [helpCardData]="helpData"></pwj-help-card>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</section>
